<template lang="pug">
v-row.py-6.px-1(no-gutters, justify='center')
  v-col
    v-expansion-panels(v-model='panel')
      v-expansion-panel.my-1(:key='0')
        person-expansion-header(:title='t("person.awards")', icon='mdi-seal-variant')
        v-expansion-panel-text
          v-list-item(v-for='(award, i) in awardsInfo', :key='i')
            .award-item
              .award-item-title {{ award.issuer }}
              .award-item-subtitle {{ `${award.date} - ${award.title}` }}
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { Award } from '~/interfaces/person'
defineProps({
  awardsInfo: {
    type: Array as () => Array<Award>,
    required: true,
  },
})

const panel = ref(0)
const { t } = useI18n()
</script>

<style scoped>
.award-item {
  display: grid;
  gap: 0.25rem;
}

.award-item-title {
  margin: 0.25rem 0 0;
  color: var(--color-text-strong);
  font-weight: 700;
}

.award-item-subtitle {
  color: var(--color-text-muted);
  overflow-wrap: anywhere;
}
</style>
